import { createGenericStore } from '@/stores/utils/genericStore.js'
import axios from 'axios'

const faqStoreOptions = {
  actions: {
    async fetchFaqsForBusinessSystem(businessSystemId, params = {}) {
      const normalizedBusinessSystemId = Number(businessSystemId)

      if (!Number.isInteger(normalizedBusinessSystemId) || normalizedBusinessSystemId <= 0) {
        this.items = []
        return []
      }

      return this.fetchItems({
        clear: true,
        not_paginated: true,
        business_system_id: normalizedBusinessSystemId,
        ...params,
      })
    },
    async createFaq(payload) {
      return this.itemCreate(payload)
    },
    async startEditFaq(faqId) {
      const normalizedFaqId = Number(faqId)

      if (!Number.isFinite(normalizedFaqId) || normalizedFaqId <= 0) {
        throw new Error('A valid FAQ is required to start editing.')
      }

      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.post(`${this.api}/${normalizedFaqId}/start-edit`)
        this.itemPatchState(data)

        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoading = false
      }
    },
    async publishFaq(faqId) {
      const normalizedFaqId = Number(faqId)

      if (!Number.isFinite(normalizedFaqId) || normalizedFaqId <= 0) {
        throw new Error('A valid FAQ draft is required to publish.')
      }

      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.post(`${this.api}/${normalizedFaqId}/publish`)
        this.itemPatchState(data)

        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoading = false
      }
    },
    async publishFaqVersion(faq, payload) {
      const normalizedFaqId = Number(faq?.id ?? faq)

      if (!Number.isFinite(normalizedFaqId) || normalizedFaqId <= 0) {
        throw new Error('A valid FAQ is required to publish changes.')
      }

      const faqStatus = typeof faq?.status === 'string' ? faq.status : null
      const draftFaq = faqStatus === 'draft'
        ? faq
        : await this.startEditFaq(normalizedFaqId)

      const updatedFaq = await this.itemPatch(Number(draftFaq.id), payload)
      const publishedFaq = await this.publishFaq(updatedFaq.id)

      if (publishedFaq.id !== normalizedFaqId) {
        this.itemRemoveFromState(normalizedFaqId)
      }

      return publishedFaq
    },
  },
}

export const useFaqStore = createGenericStore(
  'faq',
  '/api/v1/faqs',
  faqStoreOptions
)
